module.exports = __webpack_public_path__ + "41a4c4aff391c4869cd97493be61ecba.MP3";